import { createContext, useContext } from 'react';

export const ErrorContext = createContext<unknown>(undefined);

export function useErrorContext() {
  return useContext(ErrorContext);
}
